import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { cn } from "src/lib/cn";
import { Text } from "src/sudokit/components/Text";
import ChevronDownIcon from "./icons/ChevronDownIcon";

type Props = {
  instructions: string;
  label?: string;
};

export const CTACollapsedInstructions: React.FC<Props> = ({ instructions, label = "Custom instructions" }) => {
  const [expanded, setExpanded] = useState(false);

  if (!instructions.trim()) return null;

  return (
    <div className="px-3 pb-2">
      <div
        className={cn(
          "border border-solid border-app-grey-3 rounded-lg",
          "hover:border-app-grey-2 transition-colors"
        )}
      >
        <button
          type="button"
          onClick={() => setExpanded(!expanded)}
          className={cn(
            "flex items-center gap-1.5 w-full bg-transparent cursor-pointer p-0 px-2.5 py-2",
            "text-app-grey-1 hover:text-app-grey-0 transition-colors"
          )}
        >
          <div className={cn("flex-shrink-0 text-app-grey-2 transition-transform", expanded && "rotate-180")}>
            <ChevronDownIcon width={10} height={7} color="currentColor" />
          </div>
          <Text size="xs" color="grey-1">
            {label}
          </Text>
        </button>
        <AnimatePresence>
          {expanded && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.15, ease: "easeOut" }}
              className="overflow-hidden"
            >
              <Text size="xs" color="grey-1" className="pb-2 px-2.5 whitespace-pre-wrap break-words">
                {instructions}
              </Text>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};
